var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"footer",class:{ active:_vm.activeFooter}},[_c('h3',[_vm._v("Custom Banner Vue")]),_c('div',{staticClass:"from_develop"},[_c('p',[_vm._v("Desarrollado por "),_c('a',{attrs:{"href":"https://bahiaxip.com"}},[_vm._v("bahiaxip")]),_vm._v(" © "+_vm._s(_vm.year))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }